module.exports = __webpack_public_path__ + "img/pin.f486d989.svg";